/**
 * ConnectionStatus banner (T069).
 *
 * Shown when the store's connectionStatus is 'connecting' or 'lost'.
 * For 'lost' it also provides a reload CTA so the user can recover.
 * When 'connected' or 'idle' the component renders nothing.
 */
import { useTranslation } from 'react-i18next'
import { useRoomStore } from '../room/store.js'
import styles from './ConnectionStatus.module.css'

export function ConnectionStatus() {
  const { t } = useTranslation()
  const status = useRoomStore((s) => s.connectionStatus)

  if (status === 'idle' || status === 'connected') return null

  const isLost = status === 'lost'

  return (
    <div
      className={`${styles.banner} ${isLost ? styles.lost : styles.connecting}`}
      role="status"
      aria-live="polite"
    >
      <span>{isLost ? t('status.lost') : t('status.connecting')}</span>
      {isLost && (
        <button
          className={styles.reloadBtn}
          onClick={() => window.location.reload()}
        >
          {t('status.reload')}
        </button>
      )}
    </div>
  )
}
